<template>
  <div>
    <Table border stripe :columns="columns" :data="data">
      <template slot="action" slot-scope="{ row }">
        <el-button :disabled="false" type="primary" @click="printHandle(row)">打印</el-button>
      </template>
    </Table>
    <div style="margin-top: 13px; text-align: right">
      <el-pagination
        :current-page="pagination.currentPage"
        :page-sizes="pagination.pageSizeOptions"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    taskInfo: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },

  data() {
    return {
      pagination: {
        currentPage: 1,
        pageSize: 5,
        pageSizeOptions: [5, 10],
        total: 0,
      },
      data: [],
      columns: [
        {
          title: "序列号",
          key: "itemSn",
        },
        {
          title: "操作",
          align: "center",
          width: 80,
          slot: "action",
        },
      ],
    };
  },

  mounted() {
    this.getCode(1);
  },

  methods: {
    getCode() {
      this.$http
        .get(
          "basic",
          "productionManage/listSN?id=" +
            this.taskInfo.pkid +
            "&pageNum=" +
            this.pagination.currentPage +
            "&pageSize=" +
            this.pagination.pageSize
        )
        .then((res) => {
          if (res.success) {
            this.data = [];
            if (res.data.records.length) {
              res.data.records.forEach((item) => {
                this.data.push({ itemSn: item });
              });
            }
            this.pagination.total = res.data.total;
          }
        });
    },

    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.getCode();
    },

    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.getCode();
    },

    printHandle(row) {
      if (!this.taskInfo.productionType) {
        const params = {
          unitName: this.taskInfo.unitName,
          materialName: this.taskInfo.materialName,
          spec: this.taskInfo.specification,
          billNo: this.taskInfo.billNo,
          salesOrderNo: this.taskInfo.salesOrderNo,
          data: [row],
        };
        this.goTo("/materialsTagsPrint", JSON.stringify(params));
      } else {
        const params = {
          orderInfo: this.taskInfo,
          data: [row],
        };
        this.goTo("/productCardPrint", JSON.stringify(params));
      }
    },

    goTo(path, params) {
      const routeUrl = this.$router.resolve({
        path: path,
        query: {
          params: params,
        },
      });
      window.open(routeUrl.href, "_blank");
    },
  },
};
</script>
